import React, { useMemo } from "react";
import { useInView } from "../../../../config/commonfunctions"; // Assuming this useInView is the sticky version (once shown, remains true)
import "./Writemessages.css";

  // ... (Your message data remains the same)
// const messages = [
//   { text: "💍 Congratulations to the lovely couple!", name: " Alice" },
//   { text: "Wishing you a lifetime of love and joy.", name: " Bob" },
//   { text: "So happy to celebrate this special day with you. May your love continue to grow deeper with each passing year.", name: " Charlie" },
//   { text: "🥂 Cheers to your forever!", name: " Dana" },
//   { text: "Cheers to your forever! May your journey ahead be filled with joy, adventure, and endless support for each other.", name: " Emma" },
//   { text: "So happy to celebrate with you both!", name: " Frank" },
//   { text: "✨ Wishing you endless happiness ahead.", name: " Grace" },
//   { text: "Congrats on this beautiful day!", name: " Henry" },
//   { text: "Wishing you endless love and harmony. May your marriage be filled with laughter, kindness, and cherished memories.", name: " Irene" },
//   { text: "Wishing you both a marriage full of warmth and wonder. Congratulations and thank you for letting us be part of your big day!", name: " Noah" },
//   { text: "Cheers to love and new beginnings!", name: " Olivia" },
//   { text: "🌿 Wishing you a beautiful life together.", name: " Peter" },
// ];

function Writemessages({messages}) {

  // 1. Get the ref and visibility state
  const [isVisible, componentRef] = useInView({ threshold: 0.4 });

  const CONTAINER_WIDTH = 450;
  const VISUAL_HEIGHT = 600;
  const NUM_COLS = 2;
  const NUM_IMAGES = messages.length;
  const NUM_ROWS = Math.ceil(NUM_IMAGES / NUM_COLS);

  const scatteredMessages = useMemo(() => {
    // ... (Your message positioning logic remains the same)
    const colWidth = CONTAINER_WIDTH / NUM_COLS;
    const rowHeight = VISUAL_HEIGHT / NUM_ROWS;
    const PADDING_BUFFER = 10;

    return messages.map((msg, i) => {
      const colIndex = i % NUM_COLS;
      const rowIndex = Math.floor(i / NUM_COLS);
      const xBase = (colIndex * colWidth) + PADDING_BUFFER;
      const yBase = (rowIndex * rowHeight) + PADDING_BUFFER;
      const jitterX = (Math.random() - 0.5) * 20;
      const jitterY = (Math.random() - 0.5) * 20;
      const rotation = (Math.random() - 0.5) * 20;
      const translateX = xBase + jitterX;
      const translateY = yBase + jitterY;

      return {
        text: msg.text,
        name: msg.name,
        style: {
          transform: `translate(${translateX}px, ${translateY}px) rotate(${rotation}deg)`,
          zIndex: Math.floor(Math.random() * 20),
          // Set the staggered delay inline
          animationDelay: `${i * 100}ms`,
        }
      };
    });
  }, [messages,messages.length]);
  
  // 2. Determine the class to trigger the animation
  // NOTE: This class is not strictly needed for this solution but kept for compatibility.
  const animationTriggerClass = isVisible ? 'is-visible' : '';


  return (
    <div className="GbWritemessages_root" style={{ display: 'flex', flexDirection: 'column', minHeight: 950, height: 950 }}>
      <div 
        ref={componentRef}
        className={`GbWritemessages_imgroot ${animationTriggerClass}`} 
        style={{ height: `${VISUAL_HEIGHT}px`, marginBottom: 80 }}
      >
        {isVisible && scatteredMessages.map((msg, i) => ( 
          <div
            key={i}
            className="msgNode"
            style={msg.style}
          >
            <p className="message-text">{msg.text}</p>
            <p className="message-name">{msg.name}</p>
          </div>
        ))}
      </div>
      <div className='Gbdrawings_subtitle' style={{marginTop:40,  }}>
        Every heartfelt wish, memory, and piece of advice collected here from your guests.
      </div>
    </div>
  );
}

export default Writemessages;